export enum SolicitacoesRetornoItensNotaTypes {
  'ITENS_NOTA_REQUEST' = '@solicitacoesRetorno/ITENS_NOTA_REQUEST',
  'ITENS_NOTA_SUCCESS' = '@solicitacoesRetorno/ITENS_NOTA_SUCCESS',
  'ITENS_NOTA_FAILURE' = '@solicitacoesRetorno/ITENS_NOTA_FAILURE',
}

export interface IItensNota {
  nuNota: number;
  volume: string;
  quantidade: number;
  descricaoProduto: string;
  codProduto: number;
  controle: string;
  referencia: string;
  quantidadePendente: number;
  valorTotal: number;
  pesoBruto: number;
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface SolicitacoesRetornoItensNotaState {
  data: IItensNota[];
  loading: boolean;
  error: boolean;
  filter: any;
  sorter: any;
  pagination: Pagination;
}
